const initialState = {
    fileUploadMsg: {},
    searchDropdownValue: '',
  };
  
  const commonReducer = (state = initialState, action) => {
    switch (action.type) {
  
      
      case "SEARCH_DROPDOWN_VALUE": {
        return {
          ...state,
          searchDropdownValue: action.payload
        }
      }

      case "BULK_UPDATE_FILE_UPLOAD": {
        return {
          ...state,
          fileUploadMsg: action.payload
        }
      }
  
      default:
        return state;
    }
  };
  
  export default commonReducer;
  